<template>
  <v-col md="1" sm="1" class="text-right px-0 py-0">
    <v-btn
      text
      @click="() => this.$emit('changePage')"
      class="btn-class min-w-auto px-0"
      :color="$vuetify.theme.themes.light.primary"
      :class="{ disabled: this.currentPage === this.page }"
      v-if="pageNumberLinks.length > 1"
    >
      <!-- <v-icon>keyboard_arrow_left</v-icon> -->
      <v-icon :class="{ double_arrow_left: isActive }">double_arrow</v-icon>
    </v-btn>
  </v-col>
</template>
<script>
export default {
  name: 'Arrow',
  props: {
    currentPage: Number,
    pageNumberLinks: Array,
    page: Number,
    isActive: {
      required: false,
      default: '',
      type: String
    }
  }
};
</script>
<style scoped>
.min-w-auto {
  min-width: auto !important;
}
.disabled {
  color: #dadada !important;
}
.btn-class {
  color: #58e2c2;
}
.double_arrow_left {
  transform: rotate(180deg);
}
</style>
